<template>
    <div class="ly-search-dialog">
        <Button :icon="attrs.icon" type="success" @click="setModalShow(true)">
           {{attrs.title}}
        </Button>
        <Modal v-model="modal" title="保护名单搜索"  width="1000">
             <Row>
                <Form ref="lyForm"  @keydown.native.enter.prevent="keyDownEvent">
                    <Col span="20">
                        <Input  v-model="bindForm.customer_name" placeholder="请输入客户名称关键字"/>
                    </Col>
                    <Col span="4">
                        <FormItem class="ly-form-buttons" style="margin-left: 10px;">
                            <Button type="primary" @click="queryData" icon="ios-search">搜&nbsp;索</Button>
                        </FormItem>
                    </Col>
                </Form>
            </Row>
            <template v-if="currConfig && currConfig.children" v-for="el in currConfig.children">
                <ly-hoc :attrs="el"></ly-hoc>
            </template>
            <Spin size="large" fix v-if="isSpinShow"></Spin>
        </Modal>
    </div>
</template>
<script>
    /**
     * 具有搜索功能的弹窗
     */
    import CompEventMixin from '@/utils/compEvent.mixin'
    export default {
        name: 'LySearchDialog',
        mixins: [CompEventMixin],
        props: {
            attrs: {
                type: Object,
                default: _ => new Object()
            }
        },
        data () {
            return  {
                modal: false,
                isSpinShow: false,
                isInitForm: true, // 初始化设置form的数据
                bindForm: {
                    customer_name: ''
                },
                currConfig: {
                    children: [{
                        "name":"ly-table",
                        "mark":"dialogTable",
                        "isSubmit":false,
                        "children": [{
                            "name":"ly-text",
                            "field": "customer_name_account",
                            "title": "客户名称/账户登录名"
                        }, {
                            "name":"ly-text",
                            "field": "customer_type",
                            "title": "客户类型"
                        }, {
                            "name":"ly-text",
                            "field": "agent_name_account",
                            "title": "归属代理商/账户登录名"
                        },{
                            "name":"ly-text",
                            "field": "area",
                            "title": "企业所在城市",
                            "width": 120
                        }, {
                            "name":"ly-text",
                            "field": "review_status",
                            "title": "审核进度",
                            "width": 100
                        }, {
                            "name":"ly-baohu-status",
                            "field": "current_status",
                            "title": "状态",
                            "width": 100
                        }, {
                            "name":"ly-text",
                            "field": "submit_time",
                            "title": "提交时间",
                            "width": 120
                        }]
                    }]
                }
            }
        },
        methods: {
            /**
             * 获得页面数据后的回调函数，在mixin的监听中调用
             */
            pageDataCallback () {
                if (!this.isInitForm) return
                // 数据变化后，设置字段的值
                for (let key in this.bindForm) {
                    this.bindForm[key] = this.page[key]
                }
                this.isInitForm = false
            },
            setModalShow (bool) {
                this.modal = bool
                if (bool) {
                    this.isInitForm = true
                    this.queryData()
                }
            },
            queryData () {
                this.isSpinShow = true
                //请求页面数据
                this.$api.query(this.attrs.api, this.bindForm).then((rs) => {
                    // 向所有子组件，发送页面数据
                    this.$eventHub.$emit(this.$events.PAGE_DATA, {
                        dialogTable: rs.table
                    })
                    this.isSpinShow = false
                }).catch((err) => {
                    this.$Message.error({content: err, duration: 5 })
                    this.isSpinShow = false
                })
            },
            keyDownEvent () {}
        }
    }
</script>
<style>
    .ly-search-dialog {
        display: inline-block;
    }
</style>


// WEBPACK FOOTER //
// ../projectCore/src/components/search-dialog/src/index.vue